import { Injectable } from '@angular/core';

import { ApiProvider } from './api/api';

@Injectable()
export class AuditProvider {
  constructor(private api: ApiProvider) {}

  list(filters: any = {}) {
    return this.api.get('master/v2/audit/events', { params: this.clean(filters) });
  }

  detail(id: number) {
    return this.api.get(`master/v2/audit/events/${id}`);
  }

  requestEvents(requestId: string) {
    return this.api.get(`master/v2/audit/requests/${encodeURIComponent(requestId)}`);
  }

  private clean(values: any) {
    const cleaned: any = {};

    Object.keys(values || {}).forEach((key: string) => {
      const value = values[key];
      if (value !== null && value !== undefined && value !== '') {
        cleaned[key] = value;
      }
    });

    return cleaned;
  }
}
